export const deploymentIds = {
  training: {
    dev: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    stage: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    prod: "0c016b43-e79f-45f5-bfbe-db3b7587e897",
  },
  schools: {
    dev: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    stage: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    prod: "ef5cd32b-1ac6-4f6d-8b07-6cbe7796d948",
  },
  group: {
    dev: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    stage: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    prod: "350a9a39-219b-4c82-9da9-b621a52adc36",
  },
  academy: {
    dev: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    stage: "93c75df2-a13a-4d5b-a628-8d2e31a46489",
    prod: "6ea239a7-af52-46f6-884a-5329934b9a36",
  },
};
